import { api } from "./api";

export const edafaSarfApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getEdafaSarf: builder.query({
      query: () => "api/Stock/Trans",
      providesTags: ["edafaSarf"],
    }),
    getEdafaSarfByTransDoc: builder.query({
      query: (transDoc) => `api/Stock/Trans?TransDoc=${transDoc}`,
      providesTags: ["edafaSarf"],
    }),
    addEdafaSarf: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Trans",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["edafaSarf"],
    }),
    editEdafaSarf: builder.mutation({
      query: (formData) => ({
        url: "api/Stock/Trans",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["edafaSarf"],
    }),
    deleteEdafaSarf: builder.mutation({
      query: (transId) => ({
        url: `api/Stock/Trans?TransID=${transId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["edafaSarf"],
    }),
  }),
});

export const {
  useGetEdafaSarfQuery,
  useLazyGetEdafaSarfByTransDocQuery,
  useAddEdafaSarfMutation,
  useEditEdafaSarfMutation,
  useDeleteEdafaSarfMutation,
} = edafaSarfApi;
